import theme from "../tailwind.config";
export const useTheme = () => {
  // created a hook so that future iterations have more flexibility
  return theme;
};
